import { Switch } from "@headlessui/react";
import { useState } from "react";

function classNames(...classes: string[]) {
    return classes.filter(Boolean).join(" ");
}

interface SimpleToggleProps {
    id?: string;
    initialState?: boolean;
    onChangeListener?: (enabled: boolean) => void;
    testId?: string;
}

export default function SimpleToggle({
    id,
    initialState = false,
    onChangeListener,
    testId,
}: SimpleToggleProps) {
    const [enabled, setEnabled] = useState(initialState);

    const onChange = (enabled: boolean) => {
        setEnabled(enabled);
        onChangeListener?.(enabled);
    };

    return (
        <Switch
            id={id}
            data-testid={testId ?? "toggle-switch"}
            checked={enabled}
            onChange={onChange}
            className={classNames(
                enabled ? "bg-brand-red" : "bg-brand-border",
                "relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200 ease-in-out",
            )}
        >
            <span className="sr-only">Use setting</span>
            <span
                aria-hidden="true"
                className={classNames(
                    enabled ? "translate-x-5" : "translate-x-0",
                    "pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow-sm ring-0 transition duration-200 ease-in-out",
                )}
            />
        </Switch>
    );
}
